import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "text-center mb-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "Login", -1)
const _hoisted_3 = {
  key: 0,
  class: "error"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 2,
  disabled: ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => ($setup.handleSubmit && $setup.handleSubmit(...args)), ["prevent"]))
    }, [
      _hoisted_2,
      _withDirectives(_createElementVNode("input", {
        type: "email",
        placeholder: "Email",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.email) = $event))
      }, null, 512), [
        [_vModelText, $setup.email]
      ]),
      _withDirectives(_createElementVNode("input", {
        type: "password",
        placeholder: "Password",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.password) = $event))
      }, null, 512), [
        [_vModelText, $setup.password]
      ]),
      ($setup.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString($setup.error), 1))
        : _createCommentVNode("", true),
      (!$setup.isPending)
        ? (_openBlock(), _createElementBlock("button", _hoisted_4, "Continue"))
        : _createCommentVNode("", true),
      ($setup.isPending)
        ? (_openBlock(), _createElementBlock("button", _hoisted_5, "Loading"))
        : _createCommentVNode("", true)
    ], 32)
  ]))
}